// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EUGo","controls":"styles_controls__3Scev","charLimit":"styles_charLimit__1JFdM","input":"styles_input__1GZYG","send":"styles_send__33gOK"};